/**
 * Provides generic functions for arrays
 */
export namespace ArrayUtilities {
  /**
   * Compares the first collection against the second and determines if there is any intersection between the two (set-theory)
   * @param first The first collection that is compared against the second
   * @param second The second collection that is compared against the first
   * @param comparer The comparer to use when determining equality
   * @returns True if at least 1 value is shared between the two collections
   */
  export function hasIntersection<T>(first: T[], second: T[], comparer?: (first:T, second:T) => boolean): boolean {
    let containsValue = false;

    if (!first || !second) {
      // One of the collections are null so we cannot have an intersection
      return false;
    }

    for (let firstValue of first) {
      if (containsValue) {
        break;
      }

      for (let secondValue of second) {
        if (comparer) {
          // If we have been provided a comparer then we should not use the default equality check
          if (comparer(firstValue, secondValue)) {
            containsValue = true;
            break;
          }
        } else if (firstValue === secondValue) {
          containsValue = true;
          break;
        }
      }
    }
    return containsValue;
  }
}